import FileUploadWithPreview, { SelectedFilesType } from "components/blocks/FileUploadWithPreview";
import Modal, { ModalProps } from "components/blocks/Modal";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderLocalItemResult } from "services/orders/models/OrdersTypes";
import FormInput from "components/blocks/FormInput";
import FormCheckBox from "components/blocks/FormCheckBox";

const PayrollOfficerModal: React.FC<
  ModalProps & {
    onSubmit: (notes: string, receiptId: string, fundAmount?: number) => Promise<any>;
    isSubmitting: boolean;
    order?: OrderLocalItemResult | null;
  }
> = (props) => {
  const { isOpen, onClose, onSubmit, isSubmitting, order } = props;
  const { t, i18n } = useTranslation(["Orders"]);
  const [notes, setNotes] = useState("");
  const [files, setFiles] = useState<SelectedFilesType[]>([]);
  const [changeReward, setChangeReward] = useState(false);
  const [fundAmount, setFundAmount] = useState<number>(order?.fundingAmount ?? 0);
  useEffect(() => {
    if(order?.fundingAmount) setFundAmount(order.fundingAmount);
  }, [order?.fundingAmount, i18n.language]);

  const onCancel = () => {
    onClose?.();
  };

  return (
    <Modal
      containerClassName="bg-white pb-2"
      isOpen={isOpen}
      onClose={onClose}
      title={t("attachTransferReceipt")}
      withHeaderBorder
      size="lg"
      titleClassName="fs-6 text-dark"
      bodyMargin="py-3"
    >
      <FileUploadWithPreview
        files={files}
        setFiles={setFiles}
        maxNumberOfFiles={1}
        label={t("transferReceipt")}
        clickHereForLabel={t("toAttachReceipt")}
      />
      <label className="form-label mt-2">{t("Common:notes")}</label>
      <textarea
        className={`form-control`}
        rows={5}
        placeholder={t("Common:notes")}
        onChange={(e) => setNotes(e.target.value)}
        style={{ resize: "none" }}
      />

      <div
        className={`form-check mt-3 d-flex align-items-center gap-2   `}
      >
      
        <input
          className="form-check-input m-0"
          type="checkbox"
          id="changeRewardCheckbox"
          checked={changeReward}
          onChange={(e) => setChangeReward(e.target.checked)}
        />
        <label className="form-check-label m-0" htmlFor="changeRewardCheckbox">
          {t("changeResearcherReward")}
        </label>
      </div>

      {changeReward && (
        <div className="mt-3">
          <label className="form-label">{t("fundAmount")}</label>
          <input
            type="number"
            className="form-control"
            value={fundAmount}
            onChange={(e) => setFundAmount(Number(e.target.value))}
            min={0}
            step={0.01}
          />
        </div>
      )}

      <div className="divider mt-3"></div>

      <div className="d-flex justify-content-center gap-2 w-100">
        <button type="button" className="btn text-dark rounded-3 p-10-32P" onClick={onCancel}>
          {t("Common:cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary rounded-3 p-10-32P"
          disabled={!notes.length || isSubmitting || !files.length}
          onClick={async () => {
            if (!notes.length) return;

            await onSubmit(notes, files[0]?.uuid, changeReward ? fundAmount : undefined);
          }}
        >
          {!isSubmitting ? t("Common:save") : <div className="custom-loader"></div>}
        </button>
      </div>
    </Modal>
  );
};

export default PayrollOfficerModal;